export default __webpack_public_path__ + "static/assets/cloudinaryLoader.ad161750.svg";